import { api } from '../api';
import { GetTableTemplateDto, TableTemplateResponseDto } from './templateFilters';
import { CreateTemplateDto, UpdateTemplateDto } from '@repo/common-types';
import { TemplateDto } from './template-types';
import { AxiosResponse } from 'axios';

export const fetchAllTemplatesRest = async (): Promise<TemplateDto[]> => {
  const response = await api.get<TableTemplateResponseDto>(`/v1/admin/table-templates`, {
    params: { take: 1000 }, // Get a large number to fetch all templates
  });
  return response.data.tableTemplates;
};

export const fetchTemplatesRest = async (
  getTableTemplateDto: GetTableTemplateDto,
): Promise<TableTemplateResponseDto> => {
  const response = await api.get<TableTemplateResponseDto>(`/v1/admin/table-templates`, {
    params: { ...getTableTemplateDto },
  });
  return response.data;
};

export const fetchTemplateByIdRest = async (id: string) => {
  return await api.get<TemplateDto>(`/v1/admin/table-templates/${id}`);
};

export const createTemplateRest = async (params: CreateTemplateDto) => {
  return await api.post<unknown, AxiosResponse<TemplateDto>, CreateTemplateDto>('/v1/admin/table-templates', params);
};

export const updateTemplateRest = async (params: UpdateTemplateDto) => {
  return await api.put<TemplateDto>(`/v1/admin/table-templates/${params.id}`, params);
};

export const deleteTemplateRest = async (templateId: string) => {
  return await api.delete(`/v1/admin/table-templates/${templateId}`);
};
